<template>
  <div :id="gId" :class="ns.b('wrapper')" />
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import { gitGraphProps } from './git-graph-types'
import useGitGraph from './use-git-graph'

defineOptions({ name: 'LtGitGraph' })
const props = defineProps(gitGraphProps)

const ns = useNamespace('graph')
const isDark = ref(false)
const { initTheme, initGraph, getGraphId } = useGitGraph(isDark)

const gId = getGraphId()
onMounted(() => {
  nextTick(() => {
    const graphEle = document.querySelectorAll(`#${gId}`)[0] as HTMLElement
    initTheme()
    initGraph(graphEle, props.option, isDark.value)
  })
})
</script>
